/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines the type of relationship for lookup fields
 * @export
 */
export const WebApiModelsEnumerationTypesLookupRelationType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type WebApiModelsEnumerationTypesLookupRelationType = typeof WebApiModelsEnumerationTypesLookupRelationType[keyof typeof WebApiModelsEnumerationTypesLookupRelationType];


export function WebApiModelsEnumerationTypesLookupRelationTypeFromJSON(json: any): WebApiModelsEnumerationTypesLookupRelationType {
    return WebApiModelsEnumerationTypesLookupRelationTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesLookupRelationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesLookupRelationType {
    return json as WebApiModelsEnumerationTypesLookupRelationType;
}

export function WebApiModelsEnumerationTypesLookupRelationTypeToJSON(value?: WebApiModelsEnumerationTypesLookupRelationType | null): any {
    return value as any;
}

